import api from 'services/api';
import _ from 'lodash';
import { Dispatch } from 'redux';
import Logger from 'components/common/helpers/devConsoleLog';
import { IShareAnetaPackData, AnetapackOptions } from 'types';
import {
  GET_ANETA_PACKS,
  GET_CURRENT_ANETA_PACK,
  CHANGE_AP_OPTIONS,
  SET_ANETAPACK_ERROR,
} from 'actions/actionTypes';
// import { showSpinner, hideSpinner } from './spinner';

export const getAllAnetaPacks = (
  curator?: string[],
  grade?: string[],
  skill?: string[],
  interest?: string[]
) => async (dispatch: Dispatch): Promise<void> => {
  try {
    const curatorString =
      (curator &&
        !_.isEmpty(curator) &&
        `curator=${curator.join('&curator=').toLowerCase()}&`) ||
      '';
    const gradeString =
      (grade &&
        !_.isEmpty(grade) &&
        `grade=${grade.join('&grade=').toLowerCase()}&`) ||
      '';
    const skillString =
      (skill && !_.isEmpty(skill) && `skill=${skill.join('&skill=')}&`) || '';

    const interestString =
      (interest &&
        !_.isEmpty(interest) &&
        `interest=${interest.join('&interest=')}`) ||
      '';

    const { data } = await api.get(
      `/aneta-packs?${curatorString}${gradeString}${skillString}${interestString}`
    );
    dispatch({
      type: GET_ANETA_PACKS,
      payload: data,
    });
  } catch (error) {
    Logger('getAllAnetaPacks error:', error);
  }
};

export const getAnetaPackById = (id: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    const { data } = await api.get(`/aneta-packs/${id}`);
    dispatch({
      type: GET_CURRENT_ANETA_PACK,
      payload: data,
    });
  } catch (error) {
    Logger('getAnetaPackById error:', error);
  }
};

export const shareAnetaPacks = (data: IShareAnetaPackData) => async (
  dispatch: Dispatch
): Promise<void> => {
  dispatch({
    type: SET_ANETAPACK_ERROR,
    payload: [],
  });
  try {
    await api.post(`/aneta-packs`, data);
  } catch (error) {
    dispatch({
      type: SET_ANETAPACK_ERROR,
      payload: error.response.data?.message,
    });
    Logger('shareAnetaPacks error:', error);
  }
};

export const changeOptions = (data: AnetapackOptions) => async (
  dispatch: Dispatch
): Promise<void> => {
  dispatch({
    type: CHANGE_AP_OPTIONS,
    payload: data,
  });
};
